import { MaintenanceMessage } from 'api';
import * as actions from './actionTypes';

export const getMaintenanceStatus = () => ({
	type: actions.GET_MAINTENANCE_STATUS
})

export const setMaintenanceStatus = (payload: MaintenanceMessage[]) => ({
	type: actions.SET_MAINTENANCE_STATUS,
	payload
})

export const setNewMaintenance = (payload: MaintenanceMessage) => ({
	type: actions.SET_NEW_MAINTENANCE,
	payload
})

export const maintenanceStatusSeen = () => ({
	type: actions.MAINTENANCE_STATUS_SEEN
})

export const setAppInitialization = (payload: boolean) => ({
	type: actions.APP_INITIALIZED,
	payload
})